import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { useLanguage } from '../../context/LanguageContext';
import { useEscaCopy } from '../../i18n/escaCopy';
const EASE = [0.23, 1, 0.32, 1] as const;
const PORTRAIT = 'https://cdn.magicpatterns.com/uploads/pB9gorEFzofZX96xhoHuNx/telegram-cloud-document-2-5386561911775076958.jpg';
export function FounderSection() {
  const {
    lang
  } = useLanguage();
  const c = useEscaCopy(lang);
  const ref = useRef<HTMLDivElement>(null);
  const inView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="about" className="bg-sand py-20 lg:py-28" ref={ref} data-id="element-380" data-mp="3kl47bpfz7r7x">
      <div className="max-w-[88rem] mx-auto px-5 sm:px-8" data-id="element-381" data-mp="36tfqx9yp2gl5">
        <div className="grid lg:grid-cols-[45fr_55fr] gap-10 lg:gap-20 items-center" data-id="element-382" data-mp="3asommkdaoojc">
          <motion.div initial={{
          opacity: 0,
          y: 18
        }} animate={inView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          ease: EASE
        }} className="relative" data-id="element-383" data-mp="2wtymevv6i8qr">
            <div className="relative aspect-[4/5] overflow-hidden bg-ink" data-id="element-384" data-mp="36u7qlx6o2oz2">
              <img src={PORTRAIT} alt={`${c.founder.name} — ${c.founder.role}`} className="w-full h-full object-cover object-top grayscale-[0.15]" loading="lazy" data-id="element-385" data-mp="31wpejxxcrtmu" />
            </div>
            <div className="absolute -bottom-3 -right-3 w-24 h-24 border-r-2 border-b-2 border-accent hidden sm:block" aria-hidden="true" data-id="element-386" data-mp="3aurmkxfi7mjm" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 18
        }} animate={inView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.1,
          ease: EASE
        }} data-id="element-387" data-mp="2j3ljc84hl8q4">
            <h2 className="esca-h2 text-ink text-balance" data-id="element-388" data-mp="2s49zp9hcrl66">
              {c.founder.title}
            </h2>

            <div className="mt-8 pb-8 border-b border-line" data-id="element-389" data-mp="24efo0v8rs2ni">
              <p className="font-display text-xl font-semibold text-ink tracking-[-0.02em]" data-id="element-390" data-mp="1zh5zrix49x19">
                {c.founder.name}
              </p>
              <p className="mt-1.5 text-[0.9375rem] text-muted" data-id="element-391" data-mp="8dnlkcpu4x01">
                {c.founder.role}
              </p>
            </div>

            <div className="mt-8 space-y-5" data-id="element-392" data-mp="d5f35xr0jse1">
              {c.founder.paragraphs.map((p, i) => <p key={i} className={i === 0 ? 'text-[1.1875rem] lg:text-[1.375rem] text-ink leading-[1.5] font-display font-medium tracking-[-0.015em]' : 'esca-lead text-muted max-w-[56ch]'} data-id="element-393" data-mp="i2f8g6g1gr43" data-mpi={i}>
                  {p}
                </p>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}